<template>
  <div>
    <div class="i0010-explain">
      <span v-html="$t('MODULE.I0010_LBL_TEXT')"></span>
    </div>
    <div style='padding:0px 0px 15px 0px;' align='center'>
      <!-- 日本国籍の方 -->
      <el-button class="i0010-button1 css-btn" @click="btn1Click()" type="primary" v-html="$t('MODULE.I0010_LBL_BTN1')"></el-button>
    </div>
    <div style='padding:0px 0px 15px 0px;' align='center'>
      <!-- 外国籍の方 -->
      <el-button class="i0010-button1 css-btn" @click="btn2Click()" type="primary" v-html="$t('MODULE.I0010_LBL_BTN2')"></el-button>
    </div>
  </div>
</template>
<script>
let url = require("@/../config/sysConfig")
export default {
  data() {
    return {

    }
  },
  methods: {
    // 日本国籍の方
    btn1Click() {
      this.$router.push({ path: url.routerUrl_I0002 })
    },
    // 外国籍の方
    btn2Click() {
      this.$router.push({ path: url.routerUrl_I0007 })
    }
  }
}
</script>
<style>
.i0010-button1 {
  margin-top: 20px;
  width: 65%;
  height: 60px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
  font-size: 10pt;
}
.i0010-explain {
  margin: 15px 5px 5px 5px;
  padding: 5px;
  /* width: 100%; */
  /* height: 100px; */
  color: red;
  border: 1px solid red;
  line-height: 2;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0010.vue